import { gql } from '@apollo/client';

export const QUERY_SUPPLIER_BUYER_LIST = gql`
  query listBuyerSupplier($input: OrggDetailsInput) {
    listBuyerSupplier(input: $input) {
      OrganizationList {
        organization {
          _id
          orgName
          orgId
          orgLogo
          configuration
        }
        status
        relationship
      }
      buyerSupplierGroupList {
        groupName
        relationship
        _id
        list {
          orgId
          _id
          orgName
          orgLogo
          activeStatus
        }
      }
    }
  }
`;

export const QUERY_BUYER_SUPPLIER_ORG_DETAILS = gql`
  query Query($orgId: String) {
    fetchSupplierBuyerOrgDetails(orgId: $orgId) {
      orgName
      _id
      orgStatus
      orgDomains
      orgAddress
      orgCity
      orgState
      orgZip
      orgCountry
      orgPhone
      orgFax
      orgEmail
      orgWebsite
      orgLogo
      orgCover
      orgDescription
      orgType
      configuration
    }
  }
`;

export const QUERY_OTHER_ORG_USERS = gql`
  query FetchOtherOrganisationUsers($input: OtherOrgId) {
    fetchOtherOrganisationUsers(input: $input) {
      message
      data {
        email
        profilePicture
        firstName
        lastName
        userSub
        organizationId
        userType
      }
    }
  }
`;

export const QUERY_MODULE_WISE_ORG_USERS = gql`
  query FetchModuleWiseOrganisationUsers($input: modulewiseOrgUsersInput) {
    fetchModuleWiseOrganisationUsers(input: $input) {
      message
      data {
        email
        profilePicture
        firstName
        lastName
        userSub
        organizationId
        userType
      }
    }
  }
`;

export const FETCH_ORG_ENTITIES = gql`
  query FetchOrgEntities(
    $fetchOrgEntitiesId: String
    $profileType: String
    $perPage: Int
    $page: Int
    $searchTerm: String
    $entityType: String
  ) {
    fetchOrgEntities(
      id: $fetchOrgEntitiesId
      profileType: $profileType
      perPage: $perPage
      page: $page
      searchTerm: $searchTerm
      entityType: $entityType
    ) {
      message
      data {
        ERPIdentifier
        entityName
        parentOrgId
        _id
      }
      pagination {
        totalCount
        page
        limit
        totalPages
        allDataRetrieved
      }
    }
  }
`;
